import classNames from 'classnames';
import type { FC } from 'react';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';

type Props = {
  allHidden: boolean;
  onHide: () => void;
  onUnhide: () => void;
};

export const HideButton: FC<Props> = ({ allHidden, onHide, onUnhide }) => {
  function handleClick(
    ev:
      | React.MouseEvent<HTMLElement>
      | React.KeyboardEvent<HTMLElement>
      | React.TouchEvent<HTMLElement>,
  ) {
    ev.stopPropagation();
    if (allHidden) {
      onUnhide();
    } else {
      onHide();
    }
  }

  return (
    <div
      className={classNames('starter-list-header-icon-button')}
      {...onClickGenerator(handleClick)}
    >
      {allHidden ? <i className="far fa-eye-slash" /> : <i className="far fa-eye" />}
    </div>
  );
};
